import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/Select";
import type { MenuProvided } from "react-instantsearch-core";
import { connectMenu } from "react-instantsearch-dom";
import { FormattedMessage } from "react-intl";

const RealEstateFundMandateMenu = connectMenu<MenuProvided>(({ refine, currentRefinement }) => {
  const options = [
    { value: "Todos", label: <FormattedMessage defaultMessage="Todos" id="P8VfZA" /> },
    { value: "Híbrido", label: <FormattedMessage defaultMessage="Híbrido" id="tSFx0p" /> },
    { value: "Renda", label: <FormattedMessage defaultMessage="Renda" id="/tdg1X" /> },
    {
      value: "Desenvolvimento para Renda",
      label: <FormattedMessage defaultMessage="Desenvolvimento para Renda" id="5bC9Vj" />,
    },
    {
      value: "Desenvolvimento para Venda",
      label: <FormattedMessage defaultMessage="Desenvolvimento para Venda" id="PPi3i7" />,
    },
    {
      value: "Títulos e Valores Mobiliários",
      label: <FormattedMessage defaultMessage="Títulos e Valores Mobiliários" id="Wjpilv" />,
    },
  ];

  const selectValue = currentRefinement || "Todos";
  const selectedOption = options.find((opt) => opt.value === selectValue);

  return (
    <div className="space-y-4">
      <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">
        <FormattedMessage defaultMessage="Mandato" id="kBgOJ9" />
      </h3>

      <Select
        value={selectValue}
        onValueChange={(value) => {
          refine(value === "Todos" ? "" : value);
        }}
      >
        <SelectTrigger>
          <SelectValue placeholder={<FormattedMessage defaultMessage="Todos" id="P8VfZA" />}>
            {selectedOption?.label}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
});

export default function RealEstateFundMandate() {
  return <RealEstateFundMandateMenu attribute="mandate" />;
}
